import React from "react";
import PsShareChart from "./components/psShareChart";
import CellCount from "./components/cellCount";
import Chart from "@containers/PerformanceManagement/Rightel/Dashboard/Chart/";

function mainChart() {
  return (
    <div>
      <div class="grid grid-cols-2">
        <div>
          <Chart
            data={{
              _id: {
                $oid: "656ab653b5423d94adab1d7b",
              },
              charts: [
                {
                  bucket: "1d",
                  kpi: "PS_Share",
                  node: "TEHRAN",
                  tech: "Custom",
                  type: "spline",
                  xAxis: "bottom1",
                  yAxis: "left1",
                  scope: "Province",
                },
              ],
              user: "...",
              date: 1701492307618,
              dashboardId: {
                $oid: "656ab622b5423d94adab1d76",
              },
              name: "PS SHARE",
              range: {
                name: "1 Month",
                code: "30",
              },
            }}
          ></Chart>
        </div>
        <div>
          <Chart
            data={{
              _id: {
                $oid: "656ab653b5423d94adab1d7b",
              },
              charts: [
                {
                  bucket: "1d",
                  kpi: "Total_DL_Traffic(GB)",
                  node: "TEHRAN",
                  tech: "Custom",
                  type: "spline",
                  xAxis: "bottom1",
                  yAxis: "left2",
                  scope: "Province",
                },
              ],

              user: "...",
              date: 1701492307618,
              dashboardId: {
                $oid: "656ab622b5423d94adab1d76",
              },
              name: "Total Download",
              range: {
                name: "1 Month",
                code: "30",
              },
            }}
          ></Chart>
        </div>
        <div>
          <Chart
            data={{
              _id: {
                $oid: "656ab653b5423d94adab1d7b",
              },
              charts: [
                {
                  bucket: "1d",
                  kpi: "3G cell count",
                  node: "TEHRAN",
                  tech: "Custom",
                  type: "spline",
                  xAxis: "bottom1",
                  yAxis: "right2",
                  scope: "Province",
                },
              ],

              user: "...",
              date: 1701492307618,
              dashboardId: {
                $oid: "656ab622b5423d94adab1d76",
              },
              name: "3G CELL count",
              range: {
                name: "1 Month",
                code: "30",
              },
            }}
          ></Chart>
        </div>
        <div className="h-44">
          <Chart
            data={{
              _id: {
                $oid: "656ab653b5423d94adab1d7b",
              },
              charts: [
                {
                  bucket: "1d",
                  kpi: "4G cell count",
                  node: "TEHRAN",
                  tech: "Custom",
                  type: "spline",
                  xAxis: "bottom1",
                  yAxis: "right1",
                  scope: "Province",
                },
              ],

              user: "...",
              date: 1701492307618,
              dashboardId: {
                $oid: "656ab622b5423d94adab1d76",
              },
              name: " 4G CELL count",
              range: {
                name: "1 Month",
                code: "30",
              },
            }}
          ></Chart>
        </div>
      </div>
    </div>
  );
}

export default mainChart;
